export enum CheckboxCheckedAppearance {
  Default = "Default",
  Partial = "Partial",
}
